import React, { useState, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectTranslations } from "../../app/config/i18n/slice";
import { Form, Input, Modal } from "semantic-ui-react";
import { CloseIcon } from "../../Assets/Icons/svg";
import { handleKeyDown } from "../../app/config/common/commonFunctions";
import { Spinner } from "reactstrap";

export const useQRGeneratorModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selection, setSelection] = useState([]);
  const [loading, setLoading] = useState(false);
  const t = useSelector(selectTranslations);
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  const openQRModal = useCallback((selectedItems = []) => {
    setSelection(selectedItems);
    setIsOpen(true);
  }, []);

  const QRGeneratorModal = useCallback(
    ({ formik, closeQRModal,disabled }) => {

      return (
        <Modal
          className="assets-modal download-pdf-modal"
          size="tiny"
          open={isOpen}
          onClose={closeQRModal}
        >
          <Form onSubmit={formik.handleSubmit}>
            <div className="header-container">
              <span className="assets-header">
                {t.workOrders.filter.downloadQrPdf}
              </span>
              <div>
                <span className="c-pointer text-right" onClick={closeQRModal}>
                  <CloseIcon />
                </span>
              </div>
            </div>
            <Modal.Content>
              <div className="flexbox barcode-btns mb-5">
                <button
                  type="button"
                  className={`qr-button ${
                    formik.values.size === "small" ? "active" : ""
                  }`}
                  onClick={() => formik.setFieldValue("size", "small")}
                >
                  {t.workOrders.filter.small}
                </button>

                <button
                  type="button"
                  className={`qr-button ${
                    formik.values.size === "medium" ? "active" : ""
                  }`}
                  onClick={() => formik.setFieldValue("size", "medium")}
                >
                  {t.workOrders.filter.medium}
                </button>

                <button
                  type="button"
                  className={`qr-button ${
                    formik.values.size === "large" ? "active" : ""
                  }`}
                  onClick={() => formik.setFieldValue("size", "large")}
                >
                  {t.workOrders.filter.large}
                </button>
              </div>

          
            </Modal.Content>

            <div
              className={`modal-button-container ${
                selectedLanguage == "en" ? "mr-6" : "ml-10"
              }`}
            >
              <button
                type="button"
                onClick={closeQRModal}
                className="modal-form-action-button"
              >
                {t.common.cancel}
              </button>

              <button disabled={disabled} type="submit" className="modal-form-action-button blue qr-btn">
                {loading ? (
                 
                  <Spinner color="light" size="sm">
                    <div>{null}</div>
                  </Spinner>
                ) : (
                  t.workOrders.filter.downloadPdf
                )}
              </button>
            </div>
          </Form>
        </Modal>
      );
    },
    [isOpen,loading]
  );

  return useMemo(
    () => ({
      openQRModal,
      setLoading,
      QRGeneratorModal,
      setIsOpen,
      loading,
      isOpen,
      selection,
    }),
    [openQRModal,loading,isOpen, setIsOpen,setLoading, QRGeneratorModal, selection]
  );
};
